import styled from "styled-components";

export const ButtonWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["backgroundColor", "size"].includes(prop as string),
})<{ backgroundColor: string; size?: number | null }>`
  display: flex;
  border-radius: 50px;
  cursor: pointer;
  border: 2px solid #00688d;
  width: ${({ size }) => (size ? `${size}px` : "fit-content")};
  height: 30px;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};
  background-color: ${({ backgroundColor }) => backgroundColor};
  gap: ${({ theme }) => theme.spacing(1)};
  outline: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

export const ButtonText = styled.span.withConfig({
  shouldForwardProp: (prop) => !["color", "isChecked"].includes(prop as string),
})<{ color: string; isChecked?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme, isChecked }) =>
    isChecked ? theme.colors.white : theme.colors.darkGray};
`;
